import { Component, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormsModule, NgForm, NgModelGroup } from '@angular/forms';

import { FilterService } from 'app/services/filter.service';
import { makeControlDirty } from 'app/utils/form.utils';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { NgFor, NgIf } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatCheckbox } from '@angular/material/checkbox';

interface IDescription {
  name: string;
  checked: boolean;
}

@Component({
  selector: 'app-offence-desc-tab',
  templateUrl: './offence-desc-tab.component.html',
  styleUrls: ['./offence-desc-tab.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  imports: [FormsModule, MatFormField, MatIcon, MatSuffix, MatInput, NgIf, MatProgressSpinner, MatCheckbox, NgFor],
})
export class OffenceDescTabComponent implements OnInit {
  @ViewChild('offenceDesc') ngModelGroup!: NgModelGroup;

  offenceDescGroup!: Record<string, boolean>;
  descriptions: IDescription[] = [];
  searchValue = '';
  searchValueArray: string[] = [];
  loading = false;

  constructor(private filterService: FilterService) {}

  ngOnInit() {
    const {
      appliedFilters: { violationFilter },
    } = this.filterService;

    const names = violationFilter?.names;

    this.loading = true;
    this.filterService.getOffenceDescriptions().subscribe((descriptions) => {
      this.descriptions = descriptions.map((description) => ({
        name: description,
        checked: names?.includes(description) ?? false,
      }));

      this.loading = false;
    });
  }

  allCompleted() {
    return this.descriptions.filter((x) => this.isShown(x)).every((x) => x.checked);
  }

  someComplete() {
    //Can be optimized when real data connected
    return (
      this.descriptions.filter((x) => this.isShown(x)).some((x) => x.checked) &&
      this.descriptions.filter((x) => this.isShown(x)).some((x) => !x.checked)
    );
  }

  setAll(checked: boolean) {
    this.descriptions.filter((x) => this.isShown(x)).forEach((x) => (x.checked = checked));

    makeControlDirty(this.ngModelGroup.control);
  }

  isShown(desc: IDescription): boolean {
    return this.isDescriptionShown(desc);
  }

  onChange() {
    makeControlDirty(this.ngModelGroup.control);
  }

  hasNoMatch(): boolean {
    return !this.descriptions.some((x) => this.isDescriptionShown(x));
  }

  isDescriptionShown(desc: IDescription): boolean {
    const descNameLowerCase = desc.name.toLowerCase();
    if (Array.isArray(this.searchValueArray) && this.searchValueArray.length > 0) {
      return this.searchValueArray.every((value) => descNameLowerCase.includes(value));
    }
    return true;
  }

  onSearchChange(event: string) {
    this.searchValueArray = [
      ...new Set([
        ...event
          .split(/[^a-zA-Z0-9]/)
          .map((word) => word.toLowerCase())
          .filter((word) => word.length > 0),
      ]),
    ];
  }
}
